import { create } from "zustand";

const useAsideStore = create((set) => ({
   hiddenSecondary: false,
   collapsedSecodary: false,
   // Which organization the SuperAdmin's Action Plan (Plan Summary) view is
   // scoped to. Shared here (rather than local component state) because the
   // sidebar's assessment list and the page content live in separate parts
   // of the layout tree and both need to react to it.
   selectedOrganizationId: null,

   setHiddenSecondary: (value) => set({ hiddenSecondary: value }),
   setCollapsedSecondary: (value) => set({ collapsedSecodary: value }),
   setSelectedOrganizationId: (value) => set({ selectedOrganizationId: value })
}));

export default useAsideStore;
